// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"46af9b22","511":"59537b79"}[chunkId] + ".chunk.js";
};